import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Section } from 'common/components'
import { SingleSelectField } from 'common/components'
import { isEmpty, isNil } from 'lodash'
import { useGetLanguagesQuery } from 'user/api'
import { DATE_FORMATS, MEASUREMENT_SYSTEM_FORMATS, NUMBER_FORMATS } from 'user/utils'

interface IProps {
  isLoading: boolean
}

export default function EditUserSettingsFormFields({ isLoading }: IProps) {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const { data } = useGetLanguagesQuery()

  const LANGUAGES_LIST = useMemo(() => {
    return (data ?? []).map((item) => ({ value: item.code, label: item.name }))
  }, [data])

  const isLangSelectDisabled = useMemo(
    () => isLoading || isNil(data) || isEmpty(data) || data?.length === 0,
    [data, isLoading],
  )

  return (
    <Section settingSection title={t('user.section.settings')}>
      <div className={'flex flex-col items-center w-full gap-1'}>
        <SingleSelectField
          control={control}
          data={LANGUAGES_LIST}
          isDisabled={isLangSelectDisabled}
          label={t('user.field.language')}
          name={'language'}
        />
        <SingleSelectField
          control={control}
          data={DATE_FORMATS}
          isDisabled={isLoading}
          label={t('user.field.dateFormat')}
          name={'dateFormat'}
        />
        <SingleSelectField
          control={control}
          data={NUMBER_FORMATS}
          isDisabled={isLoading}
          label={t('user.field.numberFormat')}
          name={'numberFormat'}
        />
        <SingleSelectField
          control={control}
          data={MEASUREMENT_SYSTEM_FORMATS}
          isDisabled={isLoading}
          label={t('user.field.measuremenetSystem')}
          name={'measurementSystem'}
        />
      </div>
    </Section>
  )
}
